import React, {Component, createRef} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {SSUStatus} from "../../../common/Constants";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import {flattenFormGroupObject} from "../../../common/mapper";

class PenerimaanSSUDetail extends Component {
    constructor(props) {
        super(props);
        this.initialData = {
            ssuId: null,
            orderH1: null,
            ssuDate: "01-01-2025",
            submitterName: null,
            recipientName: null,
            salesFakturNo: null,
            salesFakturDate: null,
            bookNo: null,
            kodeVariant: null,
            kodeWarna: null,
            stnkName: null,
            customerName: null,
            engineNumber: null,
            frameNumber: null,
            fakturNo: null,
            photoSSU: null,
            photoSSUUrl: null,
            ssuStatus: null,
            kodeCabang: null,
        }
        this.videoRef = createRef();
        this.canvasRef = createRef();
        this.state = {
            data: {...this.initialData},
            submitPopupContent: null,
            cameraModalVisible: false,
            mediaStream: null,
            lastStatus: null,
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            lastStatus: this.props.controls.ssuStatus.value,
        }));
    }

    handleRearCamera = () => {
        const constraints = {
            video: {facingMode: {exact: "environment"}}, // rear camera
            audio: false
        };

        navigator.mediaDevices.getUserMedia(constraints)
            .then((stream) => {
                if (this.videoRef.current) {
                    this.videoRef.current.srcObject = stream;
                }
            })
            .catch((error) => {
                console.error("Camera error: ", error);
            });
    };

    handleChangeState = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [name]: value,
            }
        }))
    }

    handleOpenCamera = async () => {
        try {
            const permissionStatus = await navigator.permissions.query({name: "camera"});
            if (permissionStatus.state === "granted") {
                this.setState((prevValue) => ({...prevValue, cameraModalVisible: true}));
                await this.openCamera();
            } else if (permissionStatus.state === "prompt") {
                this.setState((prevValue) => ({...prevValue, cameraModalVisible: true}));
                await this.openCamera();
            }
        } catch (error) {
            console.error("Error checking camera permission:", error);
        }
    };

    handleTakePhoto = () => {
        if (this.videoRef.current && this.canvasRef.current) {
            const canvas = this.canvasRef.current;
            const context = canvas.getContext("2d");

            const width = 318;
            const height = 446;

            canvas.width = width;
            canvas.height = height;

            context.drawImage(this.videoRef.current, 0, 0, canvas.width, canvas.height);
            context.drawImage(
                this.videoRef.current,
                0,
                0,
                this.videoRef.current.videoWidth,
                this.videoRef.current.videoHeight,
                0,
                0,
                width,
                height
            );

            const photoData = canvas.toDataURL("image/png");

            this.props.setValue("photoSSU", photoData);
            this.stopCamera();
        }
    };

    openCamera = async () => {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
            video: {facingMode: {ideal: "environment"}}, // rear camera
            audio: false
        });

        if (this.videoRef.current) {
            this.videoRef.current.srcObject = mediaStream;
            this.videoRef.current.play();
            this.setState((prevValue) => ({...prevValue, mediaStream: mediaStream}));
        }
    };

    stopCamera = () => {
        if (this.state.mediaStream) {
            this.state.mediaStream.getTracks().forEach((track) => track.stop());
            this.setState((prevValue) => ({...prevValue, mediaStream: null}));
        }

        if (this.videoRef.current) {
            this.videoRef.current.srcObject = null;
        }

        this.setState((prevValue) => ({...prevValue, cameraModalVisible: false}));
    };

    handleConfirmation = (batal) => {
        let controls = flattenFormGroupObject(this.props.controls);
        if (controls.ssuStatus === SSUStatus.BATAL) {
            if (this.state.submitPopupContent) {
                if (batal) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        submitPopupContent: null,
                    }));
                } else {
                    this.props.onSubmit(flattenFormGroupObject(this.props.controls));
                    this.setState((prevValue) => ({
                        ...prevValue,
                        submitPopupContent: null,
                    }));
                }
                return;
            }

            const content = (
                <div style={{textAlign: "left"}}>
                    <p>Pengajuan SSU dengan</p>
                    <br/>
                    <p>Nomor Faktur Jual: {this.props.controls.salesFakturNo.value}</p>
                    <p>Nomor Rangka: {this.props.controls.frameNumber.value}</p>
                    <p>Nomor Mesin: {this.props.controls.engineNumber.value}</p>
                    <br/>
                    <p>
                        {this.props.controls.ssuStatus.value === SSUStatus.BATAL
                            ? "akan DIBATALKAN, apakah anda yakin ?"
                            : "akan DISIMPAN, apakah anda yakin ?"}
                    </p>
                </div>
            );

            this.setState((prevValue) => ({
                ...prevValue,
                submitPopupContent: content,
            }));
        } else if (this.props.validate()) {
            if (this.state.submitPopupContent) {
                if (batal) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        submitPopupContent: null,
                    }));
                } else {
                    this.props.onSubmit(flattenFormGroupObject(this.props.controls));
                    this.setState((prevValue) => ({
                        ...prevValue,
                        submitPopupContent: null,
                    }));
                }
                return;
            }

            const content = (
                <div style={{textAlign: "left"}}>
                    <p>Pengajuan SSU dengan</p>
                    <br/>
                    <p>Nomor Faktur Jual: {this.props.controls.salesFakturNo.value}</p>
                    <p>Nomor Rangka: {this.props.controls.frameNumber.value}</p>
                    <p>Nomor Mesin: {this.props.controls.engineNumber.value}</p>
                    <br/>
                    <p>
                        {this.props.controls.ssuStatus.value === SSUStatus.BATAL
                            ? "akan DIBATALKAN, apakah anda yakin ?"
                            : "akan DISIMPAN, apakah anda yakin ?"}
                    </p>
                </div>
            );

            this.setState((prevValue) => ({
                ...prevValue,
                submitPopupContent: content,
            }));
        }
    };

    render() {
        const {controls, errors, setValue} = this.props;
        return (
            <>
                <SimpleModal
                    visible={this.props.state.detailVisible}
                    onClickClose={()=>this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <div
                                className="grid grid-2x grid-mobile-none gap-15px"
                                style={{alignItems: "center"}}
                            >
                                <div id="grid-1">
                                    <SimpleInput
                                        id="input_text_tanggal_faktur_jual"
                                        readOnly
                                        label="Tanggal Faktur Jual"
                                        value={controls.salesFakturDate.value}
                                    />
                                    <SimpleInput
                                        id="input_text_no_faktur_jual"
                                        readOnly
                                        label="No. Faktur Jual"
                                        value={controls.salesFakturNo.value}
                                    />
                                    <SimpleInput
                                        id="input_text_no_buku"
                                        readOnly
                                        label="No. Buku"
                                        value={controls.bookNo.value}
                                    />
                                    <SimpleInput
                                        id="input_text_tanggal_pengajuan"
                                        readOnly
                                        label="Tanggal Pengajuan"
                                        value={controls.ssuDate.value}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_varian"
                                        readOnly
                                        label="Nama Varian"
                                        value={controls.kodeVariant.value.label}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_warna"
                                        readOnly
                                        label="Nama Warna"
                                        value={controls.kodeWarna.value.label}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_stnk"
                                        readOnly
                                        label="Nama STNK"
                                        value={controls.stnkName.value.name}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_pembeli"
                                        readOnly
                                        label="Nama Pembeli"
                                        value={controls.customerName.value.name}
                                    />
                                    <SimpleInput
                                        id="input_text_nomor_rangka"
                                        readOnly
                                        label="Nomor Rangka"
                                        value={controls.frameNumber.value}
                                    />
                                    <SimpleInput
                                        id="input_text_nomor_mesin"
                                        readOnly
                                        label="Nomor Mesin"
                                        value={controls.engineNumber.value}
                                    />
                                    <SimpleInput
                                        id="input_text_nomor_faktur_kendaraan"
                                        name="fakturNo"
                                        mandatory
                                        label="Nomor Faktur Kendaraan"
                                        errorMessage={errors.fakturNo}
                                        value={controls.fakturNo.value}
                                        onChange={({target}) => setValue(target.name, target.value)}
                                    />
                                    <FlexView vAlignContent="center" hAlignContent="left" style={{gap: "10px"}}>
                                        <input
                                            type="checkbox"
                                            id="cancelProcess"
                                            disabled={this.state.lastStatus === SSUStatus.BATAL || this.props.salesOrderState !== "SSU_RECEIVING"}
                                            checked={controls.ssuStatus.value === SSUStatus.BATAL}
                                            onChange={({target}) =>
                                                this.props.setValue("ssuStatus", target.checked ? SSUStatus.BATAL : this.state.lastStatus)
                                            }
                                        />
                                        <label htmlFor="cancelProcess">Batalkan Proses SSU (Faktur Kendaraan)</label>
                                    </FlexView>
                                </div>
                                <FlexView hAlignContent="right" column id="grid-2" style={{height: "100%"}}>
                                    <div style={{display: "flex", gap: "15px"}}>
                                        <p>Bukti Fisik:</p>
                                        <div style={{minWidth: "318px", height: "446px"}}>
                                            <img
                                                alt=""
                                                src={controls.photoSSU.value}
                                                style={{width: "100%", height: "100%"}}
                                            />
                                        </div>
                                    </div>
                                    <SimpleButton
                                        styles={{alignSelf: "end", marginTop: "15px"}}
                                        onClick={this.handleOpenCamera}
                                    >
                                        Take Photo
                                    </SimpleButton>
                                </FlexView>
                            </div>
                            <FlexView hAlignContent="right" className="margin-top-15px">
                                <SimpleButton onClick={() => this.handleConfirmation(false)}>Simpan</SimpleButton>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.cameraModalVisible && (
                    <SimpleModal
                        visible={this.state.cameraModalVisible}
                        onClickClose={this.stopCamera}
                        styles={{width: "650px"}}
                        content={
                            <>
                                <video
                                    ref={this.videoRef}
                                    autoPlay
                                    playsInline
                                    style={{width: "100%", height: "100%"}}
                                />
                                <canvas ref={this.canvasRef} style={{display: "none"}}/>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <i
                                        role="button"
                                        className="fa fa-camera"
                                        onClick={this.handleTakePhoto}
                                        style={{
                                            fontSize: "60px",
                                            position: "absolute",
                                            color: "white",
                                            bottom: "20px",
                                            cursor: "pointer",
                                        }}
                                    ></i>
                                </div>
                            </>
                        }
                    />
                )}
                {this.state.submitPopupContent && (
                    <SimpleAlert
                        title="Information"
                        visible={!!this.state.submitPopupContent}
                        onClickClose={() => this.handleConfirmation(true)}
                        content={
                            <div>
                                {this.state.submitPopupContent}
                                <FlexView hAlignContent="right" className="margin-left-none margin-top-15px">
                                    <SimpleButton secondary onClick={() => this.handleConfirmation(true)}>
                                        Batal
                                    </SimpleButton>
                                    <SimpleButton onClick={() => this.handleConfirmation(false)}>Iya</SimpleButton>
                                </FlexView>
                            </div>
                        }
                    />
                )}
            </>
        );
    }
}

export default withFormGroup(PenerimaanSSUDetail);
